import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetOrdersRepoType, IGetOrdersRepo } from '../../repos';

export const useOrdersTableContext = () => {
  const getOrdersRepo = useService<IGetOrdersRepo>(GetOrdersRepoType);

  const onFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getOrdersRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getOrdersRepo],
  );

  return { onFetch };
};
